import { render, staticRenderFns } from "./VatContent.vue?vue&type=template&id=0678757d&scoped=true&"
import script from "./VatContent.vue?vue&type=script&lang=js&"
export * from "./VatContent.vue?vue&type=script&lang=js&"
import style0 from "./VatContent.vue?vue&type=style&index=0&id=0678757d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678757d",
  null
  
)

export default component.exports